import '../../css/frames.css';
import Menu from './Menu';
import Logo from './Logo';
import User from './User';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import { Typography, Stack, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export default function Layout({title, tab, menu, children, back, className, style}){

    return <main className='layout-main'>

        <Header tab={tab} menu={menu} />

        <nav className='layout-nav'>

            <div className='layout-nav-top'>

                <Logo />

                <Menu tab={tab} menu={menu} />

            </div>

            <User />
        </nav>

        <section className={'layout-section ' + (className || '')} style={style || {}}>

            <Title title={title} back={back}/>

            {children}

            <footer className='layout-footer'></footer>

        </section>

    </main>
}

function Title({title, back}){

    const navigate = useNavigate();

    return (title || back) && <Stack 
        direction='row' 
        justifyContent='space-between' 
        alignItems='center' 
        flexWrap='wrap'
        sx={{mt: 3, mb: 3}}
    >
        <Typography variant='h1'>
            {title}
        </Typography>

        {back && 
            <IconButton onClick={() => navigate(-1)}>
                <ArrowBack />
            </IconButton>
        }
    </Stack>
}




